<app-navbar></app-navbar>
<app-payment-method-banners *ngIf="false"></app-payment-method-banners>
<router-outlet></router-outlet>
<app-footer></app-footer>
